import React from "react";
import DialogContent from "@material-ui/core/DialogContent";
import { Typography } from "@material-ui/core";
import DialogTitle from "@material-ui/core/DialogTitle";
import { useIntl } from "react-intl";
import { messages } from "./EdgeDesktopGuide.messages";
import EdgeDesktop1 from "../../../../../Assets/edge-desktop-1.png";
import { useStyles } from "./EdgeDesktopGuide.style";

const EdgeDesktopGuide = () => {
  const intl = useIntl();
  const classes = useStyles();

  return (
    <>
      <DialogTitle id="form-dialog-title">
        {intl.formatMessage(messages.dialogTitle)}
      </DialogTitle>
      <DialogContent>
        <Typography variant="h6">
          <ol>
            <li>{intl.formatMessage(messages.step1)}</li>
            <li>{intl.formatMessage(messages.step2)}</li>
            <li>{intl.formatMessage(messages.step3)}</li>
            <img
              className={classes.image}
              src={EdgeDesktop1}
              alt={intl.formatMessage(messages.imgAltText)}
            />
          </ol>
        </Typography>
      </DialogContent>
    </>
  );
};

export default EdgeDesktopGuide;
